export default "__VITE_ASSET__Cnnn1jxB__"